import templateUrl from 'emun.salesrep/manager-bookings-rep.htm'
class ManagerBookingsRepController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    $ctrl.bookings = [];
    var timezone = moment.tz.guess();
    $ctrl.currentDate = moment.tz(timezone).format("DD/MM/YYYY");

    var context = $ctrl.context || 'manager';
    var repFilter = "";
    if (context !== 'executive') {
      var filterType = "Id";
      if (context === 'manager') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + this.repId;
    }

    $ctrl.salesreps = createAutoQuery({
      url: 'QuerySalesReps.json?' + repFilter,
      orderBy: 'Name',
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (reps) {
        reps.results.forEach(function (r) {
          $ctrl.bookings.push({
            id: r.id,
            label: r.name,
            newAccounts: 0,
            total: 0,
            lytdtotal: 0,
            pendingTotal: 0
          });
        });
        var context = $ctrl.context || 'manager';
        var filter = "ManagerId";
        if (context === 'rep') { filter = "SalesRepID"; }
        var url = 'QuerySalesYOYTotals.json?';
        url += "Sum=TotalSalesYearToDate,TotalSalesYearToDateLastYear,TotalSalesWeekToDate,TotalSalesWeekToDateLastYear";
        url += "&GroupBy=SalesRepID" + repFilter;
        if ($ctrl.onlyroad === "true") {
          url = url + "&SourceContains=Road";
        }
        $ctrl.categoryTotals = createAutoQuery({
          url: url,
          pageSize: 10000,
          criteria: {
            currentDate: $ctrl.currentDate
          },
          autoLoad: true,
          onLoaded: function (totals) {
            totals.results.forEach(function (total) {
              $ctrl.bookings.forEach(function (booking) {
                //console.info("reps", booking.id, total.salesRepID);
                if (booking.id.toUpperCase() === total.salesRepID.toUpperCase()) {
                  if ($ctrl.daterange === "YTD") {
                    booking.total = total.sumTotalSalesYearToDate;
                    booking.lytdtotal = total.sumTotalSalesYearToDateLastYear;
                  } else if ($ctrl.daterange === "WTD") {
                    booking.total = total.sumTotalSalesWeekToDate;
                  }
                }
              });
            });
          }
        });
        var startYear = moment().startOf('year').format("MM/DD/YYYY");
        this.newAccountsBookedYTDQuery = createAutoQuery({
          url: 'QuerySalesDailyCustomerTotals.json?dateRange=YTD&CountDistinct=CustomerId&SinceCreatedDate=' + startYear + '&GroupBy=SalesRepID' + repFilter,
          //                            url: 'QueryOrderLinesJoinTwos.json?dateRange=YTD&SinceRetailerCreatedOn=' + startYear + '&CountDistinct=RetailerId&GroupBy=SalesRepID&' + filter + '=' + $ctrl.repId,
          autoLoad: true,
          pageSize: 1000,
          criteria: {
            currentDate: $ctrl.currentDate
          },
          onLoaded: args => {
            if (args.total > 0) {
              args.results.forEach(function (total) {
                $ctrl.bookings.forEach(function (booking) {
                  if (booking.id.toUpperCase() === total.salesRepID.toUpperCase()) {
                    booking.newAccounts = total.countDistinctCustomerId;
                  }
                });
              });
            }
          }
        });
      }
    });
  }
}

let ManagerBookingsRep = {
  bindings: {
    repId: '<',
    daterange: '@',
    title: '@',
    onlyroad: '@',
    context: '@'
  },
  controller: ManagerBookingsRepController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default ManagerBookingsRep;